import './frame.pcss';
import angular from 'angular';
import headerContainer from './header/header-container';
import footerSearch from '../application/footer-search/footer-search.module';
import notification from './notification/notification.module';
const MODULE_NAME = 'frame';

function config($locationProvider) {
	$locationProvider.html5Mode({
		enabled:true,
		rewriteLinks:false
	});
	$locationProvider.hashPrefix('');
}

export default angular.module(MODULE_NAME, [headerContainer, footerSearch, notification])
	.config(config).name;

config.$inject = ['$locationProvider'];


